import { render, staticRenderFns } from "./requestPassword.vue?vue&type=template&id=f6724b16&scoped=true&"
import script from "./requestPassword.vue?vue&type=script&lang=ts&"
export * from "./requestPassword.vue?vue&type=script&lang=ts&"
import style0 from "./requestPassword.vue?vue&type=style&index=0&id=f6724b16&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6724b16",
  null
  
)

export default component.exports